/* src/app/shared/fixedplugin/fixedplugin.component.css */
/*# sourceMappingURL=fixedplugin.component.css.map */
